import { Component, Input } from "@angular/core";
import { StateBuilderPageComponent } from "./state-builder-page.component";
import { StateBuilderService } from "../../services/state-builder.service"; 
@Component({
    selector: "state-builder-dnd",
    templateUrl: "./state-builder-dnd.component.html",
    styleUrls: ["./state-builder-dnd.component.scss"],
    standalone: false
})
export class StateBuilderDndComponent {
    currentlyShowingAccordion: string = "rows";

	rowPaletteItems = [
		{ type: "row", count: 1 },
		{ type: "row", count: 2 },
		{ type: "row", count: 3 }
	];

	drop(evt: any): void {
		this.svc.clearDragData();
	}

	questionPaletteItems = [
		{ type: "component", value: "label" },
		{ type: "component", value: "textbox" },
		{ type: "component", value: "phoneinput" },
		{ type: "component", value: "dropdown" },
		{ type: "component", value: "checkbox" },
		{ type: "component", value: "textarea" },
		{ type: "component", value: "list" },
		{ type: "component", value: "radio" },
		{ type: "component", value: "buttonlink" },
		{ type: "component", value: "yesnotoggle" },
		{ type: "component", value: "dataquerybutton" },
		{ type: "component", value: "multiselectcheckbox" },
		{ type: "component", value: "esignature" },
		{ type: "component", value: "chiefssignature" },
		{ type: "component", value: "pdfgenerator" },
		{ type: "component", value: "pdfviewer" },
		{ type: "component", value: "flowdatatable" },
		{ type: "component", value: "casingPlanGrid" },
		{ type: "component", value: "casingPlanSchematic" },
		{ type: "component", value: "datepicker" },
		{ type: "component", value: "listentry" },
	];

	filePaletteItems = [
		{ type: "component", value: "fileupload" },
		{ type: "component", value: "fileParser" },
		{ type: "component", value: "bulkWellTransferParser" },
	];

	mapPaletteItems = [
		{ type: "component", value: "mapcontrol" },
		{ type: "component", value: "routecontrol" },
		{ type: "component", value: "areaofreviewmap" },
	];

	paymentPaletteItems = [
		{ type: "component", value: "paymentCheckout" },
		{ type: "component", value: "paymentResponse" },
	];

	reportPaletteItems = [
		{ type: "component", value: "reporttemplateselector" },
		{ type: "component", value: "reporttemplateeditor" },
		{ type: "component", value: "reportpdfview" },
		{ type: "component", value: "reportheaderimage" },
		{ type: "component", value: "reportheaderdefault" },
		{ type: "component", value: "reportfooterdefault" },
	]


	@Input() dropListId: string;
	@Input() connectedDropLists: string[];

	noEnter = () => false;

    constructor(public svc: StateBuilderService) { }

    setDragData(data: any): void {
		console.log('drag started', data);
        this.svc.setDragData(data);
    }

    toggleAccordion(showAccordion: string): void {
        if (this.currentlyShowingAccordion !== showAccordion) {
            this.currentlyShowingAccordion = showAccordion;
        } else {
            this.currentlyShowingAccordion = "";
        }

    }

}